import React, { FC } from 'react'
import {
  BACKGROUND_COLOR_DARK,
  BACKGROUND_COLOR_LIGHT,
  ColorItem,
  Colors,
} from '@/constants/styles/color'
import { THEMES } from '@/types/Creator.type'
import {
  StyledGridContainer,
  StyledGridContainerItem,
  StyledThemeColorBtn,
  StyledThemeTitle,
} from './themeChanger.style'

interface Props {
  onChangeTheme: (theme: THEMES) => void
  currentTheme: THEMES
}

type ColorPickerGroupProps = { item: ColorItem }
const ThemeChanger = ({ onChangeTheme, currentTheme }: Props) => {
  type ColorTitleProps = { type: 'Dark' | 'Light' }
  const ColorTitle: FC<ColorTitleProps> = ({ type }) => {
    return (
      <StyledThemeTitle type={type}>
        {type === 'Dark' ? 'DARK COLOR' : 'LIGHT COLOR'}
      </StyledThemeTitle>
    )
  }

  const ColorPickerGroup = ({ item }: ColorPickerGroupProps) => {
    const selectedBorder = `3px solid ${Colors.FANME_YELLOW}`
    return (
      <StyledGridContainerItem>
        <StyledThemeColorBtn
          onClick={() => onChangeTheme(item.colorName as THEMES)}
          background={item.colorValue}
          borderColor={currentTheme === item.colorName ? selectedBorder : 'none'}
        />
      </StyledGridContainerItem>
    )
  }

  return (
    <>
      <ColorTitle type="Light" />
      <StyledGridContainer>
        {BACKGROUND_COLOR_LIGHT.map(item => (
          <ColorPickerGroup item={item} key={item.colorName} />
        ))}
      </StyledGridContainer>
      <ColorTitle type="Dark" />
      <StyledGridContainer>
        {BACKGROUND_COLOR_DARK.map(item => (
          <ColorPickerGroup item={item} key={item.colorName} />
        ))}
      </StyledGridContainer>
    </>
  )
}

export default ThemeChanger
